import { render, staticRenderFns } from "./FeedbackModel.vue?vue&type=template&id=59f0d61a&scoped=true&"
import script from "./FeedbackModel.vue?vue&type=script&lang=ts&"
export * from "./FeedbackModel.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackModel.vue?vue&type=style&index=0&id=59f0d61a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f0d61a",
  null
  
)

export default component.exports